"use client";
import { r as e, t } from "./registration-BkPgmtZ2.js";
import { t as n } from "./tokens-DBlg30G8.js";
//#region src/openers/neonPack/tokens.ts
var r = n, i = t(() => import("./NeonPackOpener-Dq5bvixr.js"), r);
function a() {
	e("neon_pack", i);
}
//#endregion
export { a as n, r, i as t };

//# sourceMappingURL=neonPack-Wl0QaZuR.js.map